export default __webpack_public_path__ + "static/media/logo2.f6eccb7c.png";